import './AppError.less';
import React, { Component } from 'react';
import { AppLocaleProvider, Icon, Layout } from 'sd-ui-components';
import { observer, inject } from 'mobx-react';
import { useOidc } from '@axa-fr/react-oidc';
const { Header, Content } = Layout;
const { FormattedMessage } = AppLocaleProvider;

@inject('AuthStore')
@observer
class AppError extends Component {
  componentDidMount() {
    const { isAuthenticated, logout } = useOidc();
    if (!this.props.AuthStore.isAuthenticated) {
      if (isAuthenticated) {
        logout('/');
        this.props.AuthStore.removeStorageForLogout();
      } else {
        this.props.AuthStore.logout();
      }
    }
  }

  render() {
    return (
      <div className="error-root">
        <Layout className="error-layout">
          <Header className="error-header">
            <Icon
              icon="exclampation-circle-o"
              size={73}
              className="error-icon"
            />
          </Header>
          <Content className="error-content">
            <h1 className="error-content-title">
              <FormattedMessage id="App.Error.Title" defaultMessage="Oops!" />
            </h1>
            <h1 className="error-content-body">
              <FormattedMessage
                id="App.Error.Body"
                defaultMessage="Something went wrong."
              />
            </h1>
            <h1 className="error-content-summary">
              <FormattedMessage
                id="App.Error.Summary"
                defaultMessage="Please try again later."
              />
            </h1>
          </Content>
        </Layout>
      </div>
    );
  }
}

export default AppError;



// WEBPACK FOOTER //
// ./src/containers/AppError/AppError.jsx